import Glide from '@glidejs/glide/dist/glide.min';
import TweenMax from "gsap/TweenMax";
var jQueryBridget = require('jquery-bridget');
import Masonry from 'masonry-layout';
var Isotope = require('isotope-layout');
import InfiniteScroll from 'infinite-scroll';

var token = document.head.querySelector('meta[name="csrf-token"]').getAttribute('content');

$(document).ready(function() {
    // MASONRY layout
    if (document.getElementsByClassName('grid').length) {
        var msnry = new Masonry('.grid', {
            percentPosition: true,
            columnWidth: '.grid-sizer',
            itemSelector: '.grid-item',
            gutter: 15,
            // fitWidth: true,
        });

        jQueryBridget( 'isotope', Isotope, $ );

        var $grid = $('.grid').isotope({
            itemSelector: '.grid-item',
            masonry: {
                percentPosition: true,
                columnWidth: '.grid-sizer',
                itemSelector: '.grid-item',
                gutter: 15,
            }
        });

        // InfiniteScroll.imagesLoaded = imagesLoaded;
        var posts = document.querySelectorAll('.grid');
        imagesLoaded( posts, function() {
            msnry.layout();

            $('.filter-button-masonry').on( 'click', 'button', function() {
              $('.filter-button-masonry button').removeClass('active');
              $(this).addClass('active');
              var filterValue = $(this).attr('data-filter');
              $grid.isotope({ filter: filterValue });
            });

        });

        var infScroll = new InfiniteScroll( '.grid', {
            path: '.pagination li.active + li a',
            append: '.grid-item',
            outlayer: msnry,
            status: '.page-load-status',
            history:false,
        });
    }

    if ($('#setPosts').length > 0) {
        $(window).resize(function () {
            //location.reload();
        });
    }

    if (document.getElementsByClassName('grid_provider').length) {
        var infScroller = new InfiniteScroll( '.grid_provider', {
            path: '.pagination li.active + li a',
            append: '.free_',
            status: '.page-load-status-provider',
            history:false,
        });
    }

    if (document.getElementsByClassName('grid_variada').length) {
        var infScrollerV = new InfiniteScroll( '.grid_variada', {
            path: '.pagination li.active + li a',
            append: '.item_variada',
            status: '.page-load-status',
            history:false,
        });
        if (infScrollerV) {
            $(window).scroll(function(){
                aspect_ratio('grilla_variada', 3, 4);
            });
        }
    }

    // OVERLAY
    $(".closeOverlay").click(function() {
        document.getElementById("overlay").style.display = "none";
        $('body').css('overflow','auto');
    });
    $(".openOverlay").click(function() {
        document.getElementById("overlay").style.display = "block";
        $('body').css('overflow','hidden');
        $('#mostrar_resultados').html('');
        $('#busqueda_general').val('');
        $('#busqueda_general').focus();
    });

    function aspect_ratio(selector, x, y){
        var selector = $('.'+selector);
        var w = selector.width();
        var ratio = w*y/x;
        selector.height(parseInt(ratio));
    }

    // COBERTURA TEMPORAL activar despues
    if ($("#coberturaTemporal").length > 0) {
        setTimeout(function() {
            $("#coberturaTemporal").collapse('toggle');
            instanceTickerCarrusel.update();
            aspect_ratio('img_slider_post', 1, 1);
        }, 600);
    }

    // CAROUSEL RECOMENDADOS
    var carruselRecomendados = document.getElementById('carruselRecomendados');
    if (carruselRecomendados) {
        var instanceRecomendados = new Siema({
            selector: carruselRecomendados,
            perPage: {
                576: 2,
                768: 2,
                1024: 3
            },
            loop: true
        });

        var prev = document.querySelector('.siema-prev');
        var next = document.querySelector('.siema-next');

        prev.addEventListener('click', function() { return instanceRecomendados.prev(); });
        next.addEventListener('click', function() { return instanceRecomendados.next(); });

        Siema.prototype.addPagination = function() {
            var _this = this;
            var _sienaArrows = document.getElementById("siema-bullets");
            var _loop = function _loop(
                i) {
                var btn = document.createElement('button');

                btn.textContent = i;
                btn.addEventListener('click', function() {
                    return _this.goTo(i);
                });
                _sienaArrows.appendChild(btn);
            };
            for (var i = 0; i < this.innerElements.length; i++) {
                _loop(i);
            }
        };

        instanceRecomendados.addPagination();
    }

    // CAROUSEL EVENTOS
    // var carruselEventos = document.getElementById('carruselEventos');
    // if (carruselEventos) {
    // 	var instanceEventos = new Siema({
    // 		selector: carruselEventos,
    // 		loop: true
    // 	});

    // 	var prevEventos = document.querySelector('.siema-prev-eventos');
    // 	var nextEventos = document.querySelector('.siema-next-eventos');

    // 	prevEventos.addEventListener('click', function() {return instanceEventos.prev();});
    // 	nextEventos.addEventListener('click', function() {return instanceEventos.next();});
    // }

    // CARRUSEL ELEGIDOS POR EDITOR
    var carruselElegidosEditor = document.getElementById('carruselElegidosEditor');
    if (carruselElegidosEditor) {
        Siema.prototype.addArrows = function() {
            var _this = this;

            this.prevArrow = document.createElement('button');
            this.nextArrow = document.createElement('button');

            this.prevArrow.classList.add('prev');
            this.nextArrow.classList.add('next');
            this.selector.appendChild(this.prevArrow);
            this.selector.appendChild(this.nextArrow);

            this.prevArrow.addEventListener('click', function() { return _this.prev(); });
            this.nextArrow.addEventListener('click', function() { return _this.next(); });
        };

        var instanceElegidosEditor = new Siema({
            selector: carruselElegidosEditor,
            loop: true
        });

        instanceElegidosEditor.addArrows();
    }

    // TICKER CARRUSEL
    var tickerCarrusel = document.getElementById('tickerCarrusel');
    if (tickerCarrusel) {
        var instanceTickerCarrusel = new Glide(tickerCarrusel, {
            type: 'carousel',
            gap: 20,
            perView: 4,
            breakpoints: {
                991: {
                    perView: 3
                },
                767: {
                    perView: 2
                },
                575: {
                    perView: 1
                }
            }
        });

        var arrowNextSliderTop = document.getElementById('arrowNext-slides_tickerCarrusel');
        var arrowPrevSliderTop = document.getElementById('arrowPrev-slides_tickerCarrusel');

        arrowNextSliderTop.addEventListener('click', function() {
            instanceTickerCarrusel.go('>');
        });

        arrowPrevSliderTop.addEventListener('click', function() {
            instanceTickerCarrusel.go('<');
        });

        instanceTickerCarrusel.mount();
    }

    // ARTICULO CARRUSEL
    var articuloCarrusel = document.getElementById('articuloCarrusel');
    if (articuloCarrusel) {
        var instanceArticuloCarrusel = new Glide(articuloCarrusel, {
            type: 'carousel',
            gap: 20,
            perView: 4,
            breakpoints: {
                991: {
                    perView: 3
                },
                767: {
                    perView: 2
                },
                575: {
                    perView: 1
                }
            }
        });
        // instanceArticuloCarrusel.mount();
        var arrowNextSliderPost = document.getElementById('arrowNext-slides_articuloCarrusel');
        var arrowPrevSliderPost = document.getElementById('arrowPrev-slides_articuloCarrusel');

        arrowNextSliderPost.addEventListener('click', function() {
            instanceArticuloCarrusel.go('>');
        });

        arrowPrevSliderPost.addEventListener('click', function() {
            instanceArticuloCarrusel.go('<');
        });

        instanceArticuloCarrusel.mount();

        // $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        //     instanceSliderAlacarta.update();
        // })
    }

    // SELECCION CARRUSEL
    var botellas = document.getElementById('botellas');
    if (botellas) {
        var instanceBotellas = new Glide(botellas, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            focusAt: 'center'
        });
        var arrowNextBotellas = document.getElementById('arrowNext-botellas');
        var arrowPrevBotellas = document.getElementById('arrowPrev-botellas');

        arrowNextBotellas.addEventListener('click', function() {
            instanceBotellas.go('>');
            // hideCarrDesc();
        });

        arrowPrevBotellas.addEventListener('click', function() {
            instanceBotellas.go('<');
            // hideCarrDesc();
        });

        instanceBotellas.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceBotellas.update();
        })
    }

    var vinos = document.getElementById('vinos');
    if (vinos) {
        var instanceVinos = new Glide(vinos, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            focusAt: 'center'
        });
        var arrowNextVinos = document.getElementById('arrowNext-vinos');
        var arrowPrevVinos = document.getElementById('arrowPrev-vinos');

        arrowNextVinos.addEventListener('click', function() {
            instanceVinos.go('>');
        });

        arrowPrevVinos.addEventListener('click', function() {
            instanceVinos.go('<');
        });

        instanceVinos.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceVinos.update();
        })
    }

    var destacados = document.getElementById('destacados');
    if (destacados) {
        var instanceDestacados = new Glide(destacados, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            focusAt: 'center'
        });
        var arrowNextDestacados = document.getElementById('arrowNext-destacados');
        var arrowPrevDestacados = document.getElementById('arrowPrev-destacados');

        arrowNextDestacados.addEventListener('click', function() {
            instanceDestacados.go('>');
        });

        arrowPrevDestacados.addEventListener('click', function() {
            instanceDestacados.go('<');
        });

        instanceDestacados.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceDestacados.update();
        })
    }



    setSlider('slider0');
    setSlider('slider1');
    setSlider('slider2');

    function setSlider(slider_id) {
        var sliderAlacarta = document.getElementById(slider_id);
        if (sliderAlacarta) {
            var instanceSliderAlacarta = new Glide(sliderAlacarta, {
                type: 'carousel',
                gap: 0,
                perView: 5,
                focusAt: 'center',
                breakpoints: {
                    991: {
                        perView: 3
                    },
                    767: {
                        perView: 2
                    },
                    575: {
                        perView: 1
                    }
                }
            });
            var arrowNextSliderAlacarta = document.getElementById('arrowNext-'+slider_id);
            var arrowPrevSliderAlacarta = document.getElementById('arrowPrev-'+slider_id);

            arrowNextSliderAlacarta.addEventListener('click', function() {
                instanceSliderAlacarta.go('>');
            });

            arrowPrevSliderAlacarta.addEventListener('click', function() {
                instanceSliderAlacarta.go('<');
            });

            instanceSliderAlacarta.mount();

            $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
                instanceSliderAlacarta.update();
            })
        }
    }


    setSliderLugares('l_slider0');
    setSliderLugares('l_slider1');
    setSliderLugares('l_slider2');


    function setSliderLugares(slider_id) {
        var sliderAlacarta = document.getElementById(slider_id);
        if (sliderAlacarta) {
            var instanceSliderAlacarta = new Glide(sliderAlacarta, {
                type: 'carousel',
                gap: 0,
                perView: 2,
                // focusAt: 'center',
                breakpoints: {
                    991: {
                        perView: 2
                    },
                    767: {
                        perView: 2
                    },
                    575: {
                        perView: 1
                    }
                }
            });
            var arrowNextSliderAlacarta = document.getElementById('arrowNext-'+slider_id);
            var arrowPrevSliderAlacarta = document.getElementById('arrowPrev-'+slider_id);

            arrowNextSliderAlacarta.addEventListener('click', function() {
                instanceSliderAlacarta.go('>');
            });

            arrowPrevSliderAlacarta.addEventListener('click', function() {
                instanceSliderAlacarta.go('<');
            });

            instanceSliderAlacarta.mount();

            $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
                instanceSliderAlacarta.update();
            })
        }
    }

    // GUIA: OTRAS BOTELLAS
    var otras = document.getElementById('otras');
    if (otras) {
        var instanceOtras = new Glide(otras, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            focusAt: 'center',
            breakpoints: {
                991: {
                    perView: 3
                },
                767: {
                    perView: 2
                },
                575: {
                    perView: 1
                }
            }
        });
        var arrowNextOtras = document.getElementById('arrowNext-otras');
        var arrowPrevOtras = document.getElementById('arrowPrev-otras');

        arrowNextOtras.addEventListener('click', function() {
            instanceOtras.go('>');
        });

        arrowPrevOtras.addEventListener('click', function() {
            instanceOtras.go('<');
        });

        instanceOtras.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceOtras.update();
        })
    }

    // RECETA PAGE
    var recoBarra = document.getElementById('recobarra');
    if (recoBarra) {
        var instanceRecoBarra = new Glide(recoBarra, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            focusAt: 'center'
        });
        var arrowNextRecoBarra = document.getElementById('arrowNext-recobarra');
        var arrowPrevRecoBarra = document.getElementById('arrowPrev-recobarra');

        arrowNextRecoBarra.addEventListener('click', function() {
            instanceRecoBarra.go('>');
        });

        arrowPrevRecoBarra.addEventListener('click', function() {
            instanceRecoBarra.go('<');
        });

        instanceRecoBarra.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceRecoBarra.update();
        })
    }

    var ginger = document.getElementById('ginger');
    if (ginger) {
        var instanceGinger = new Glide(ginger, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            focusAt: 'center'
        });
        var arrowNextGinger = document.getElementById('arrowNext-ginger');
        var arrowPrevGinger = document.getElementById('arrowPrev-ginger');

        arrowNextGinger.addEventListener('click', function() {
            instanceGinger.go('>');
        });

        arrowPrevGinger.addEventListener('click', function() {
            instanceGinger.go('<');
        });

        instanceGinger.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceGinger.update();
        })
    }

    $('body').on('click', 'li.slider__frame', function() {
        var target = $(this).attr('rel');
        // var others = $(target).siblings('div');
        var others = $('div.glide-content-wrapper');

        var tl = new TimelineMax();

        tl.to(others, .4, {
            display: 'none',
            opacity: 0,
            y: 20
        });
        tl.to(target, .4, {
            display: 'block',
            opacity: 1,
            y: 0
        });
    });

    // Agrega un identificador de Pag. para renderizar estilos personalizados
    if ($('.pageIdentifier').prop('id')) {
        $('body').addClass($('.pageIdentifier').prop('id'));
    }

    // EDIT INPUTS
    // $(".editInput").on("click", function() {
    //     var el = $(this);
    //     var input = el.parent().parent().find('input');
    //     $(input).prop("disabled", function(i, v) { return !v; });
    //     input.focus();
    // });

    // MLSLIDE
    var pageEventos = document.getElementById('eventos');
    if (pageEventos) {
        (function() {
            var slideshow = new MLSlideshow(document.querySelector('.mlslideshow'));

            document.querySelector('#next-slide').addEventListener('click', function() {
                slideshow.next();
            });

            document.querySelector('#prev-slide').addEventListener('click', function() {
                slideshow.prev();
            });
        })();
    }

});
